import { v4 as uuidv4 } from "uuid";

/* Have this in factory now? */

export type UUID = string;

export const mkUUID = () => uuidv4();
